import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import AxiosConfig from "../../../services/AxiosConfig";
import styles from "../../../pages/Admin/Admin.module.css";
import { useTable } from 'react-table';
import EntreprisesTable from "./EntreprisesTable";
import FilterHamburger from "../../Filter/FilterHamburger";
import {faDownLong, faPlus, faUpLong} from "@fortawesome/free-solid-svg-icons";
import FilterHamburgerCustom from "../../Filter/FilterHamburgerCustom";
import {Field, Form, Formik} from "formik";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {fetchToSetUtilisateurActif} from "../../../services/UserService";
import {
    fetchGetEntreprises, fetchGetEntreprisesWithContratBetweenDates,
    fetchSetEntrepriseActif,
    getEntreprisesWithContratBetweenDates
} from "../../../services/EntrepriseService";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";

import TitleSecondary from "../../Title/TitleSecondary";
import styles_filter from "../../Filter/Filter.module.css";
import {updateFilterUri} from "../../../services/FilterService";
import styles_field from "../../Field/Field.module.css";
import {getStatsTabUsersPage} from "../../../services/StatsService";
import TitleMain from "../../Title/TitleMain";
import Routing from "../../../services/routing";

function EntrepriseVue({ mode = "consultation" }) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const [actif, setActif] = useState(true);
    const [contratStartDate, setContratStartDate] = useState('');
    const [contratEndDate, setContratEndDate] = useState('');
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const fetchData = async () => {
        const queryParams = location.search;

        const response = await fetchGetEntreprises(queryParams);
        if (response.success) {
            setMyApiData(response.myEntreprises);
        } else {
            handleError(response.message);
        }
    }

    const getEntreprises = async () => {
        const response = await fetchGetEntreprises();
        if (response.success) {
            setMyApiData(response.myEntreprises);
        } else {
            handleError(response.message);
        }
    }

    const getEntreprisesWithContratActif = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/entreprises_with_contrat_actif?actif=${actif}`);
            setMyApiData(response.data.myEntreprises);
            setActif(!actif);
        } catch (error) {
            console.error('error', error);
        }
    }

    const putActifOpenModal = (entreprise) => {
        const text = entreprise.actif ? "supprimer" :  "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cette entreprise ?`,
            onConfirm: async () => {
                const response = await fetchSetEntrepriseActif(entreprise);
                if (response.success) {
                    handleSuccess(response.message);
                } else {
                    handleError(response.message);
                }
                setTimeout(() => {
                    getEntreprises();
                }, 500);
            }
        });
    }

    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').textContent;
        params.delete(`filter_${key}`);
        navigate(`?${params.toString()}`);
    }

    const updateFilter = (filterKey, filterValue, resetFilter = false) => {
        const params = new URLSearchParams(location.search);

        updateFilterUri(params, filterKey, filterValue, resetFilter);

        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    const childrenOfFilter = (
        <div style={{display: "flex", flexDirection: "column", gap: "10px", margin: "35px"}}>
            <TitleSecondary text={"Filtres"}/>

            <div className={styles_filter.filtersRemoveBar}>
                {/* Aficher tous les parametres de l'url commençant par filter_ */}
                {Array.from(params.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        return (
                            <button key={key} className={styles_filter.btnFilterRemove} onClick={removeFilter}>
                                <AnnulerIcone/>
                                <span className={"filter_key"}>{key.replace('filter_', '')}</span> : {value}
                            </button>
                        );
                    })
                }
            </div>

            <div>
                <span>Entreprise</span>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    padding: "8px",
                    outline: "1px solid var(--clr-accent)",
                }}>
                    <button className={styles_filter.btnFiltre}
                            onClick={() => updateFilter('filter_entreprise', 'toutes', true)}>Toutes
                    </button>

                    <button className={styles_filter.btnFiltre}
                            onClick={() => updateFilter('filter_entreprise', 'contrat_actif', true)}>Contrat actif
                    </button>
                </div>
            </div>

            <div>
                <span>Contrat commence </span>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    padding: "8px",
                    outline: "1px solid var(--clr-accent)",
                }}>
                    <div>
                        <span>De </span>
                        <input
                            type="date"
                            value={contratStartDate}
                            onChange={(event) => {
                                setContratStartDate(event.target.value);
                            }}
                            className={styles_field.inputy}
                        />

                        <span> à </span>
                        <input
                            type="date"
                            value={contratEndDate}
                            onChange={(event) => {
                                setContratEndDate(event.target.value);
                            }}
                            className={styles_field.inputy}
                        />
                    </div>

                    <button onClick={() => {
                        const dateFilterValue = `${contratStartDate},${contratEndDate}`;
                        updateFilter('filter_contrat_date', dateFilterValue, true);
                    }} className={"btn btn_success"}>Valider
                    </button>
                </div>
            </div>
        </div>
    );

    const setImage = async (entrepriseId, urlLogo) => {
        setMyApiData(myApiData.map(entreprise => {
            if (entreprise.id === entrepriseId) {
                return {
                    ...entreprise,
                    logo: urlLogo
                };
            }
            return entreprise;
        }));
    }

    useEffect(() => {
        if (!user) return;

        fetchData();
    }, [user, mode, location.search]);

    return (
        <div className="content_tab">
            <TitleMain text="Entreprises"/>

            <FilterHamburgerCustom onReinirFilters={getEntreprises} children={childrenOfFilter}/>

            <div className={styles.navLink}>
                <Link to={Routing.routes.adminCreation}>
                    <AjouterIcone/>
                    Ajouter une entreprise
                </Link>
            </div>

            {myApiData && <EntreprisesTable entreprises={myApiData} putActifOpenModal={putActifOpenModal} setImage={setImage}/>}
        </div>
    )
}

export default EntrepriseVue;